import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

/* Services */
import { ApiService } from '@core/services/api.service';

/* Models */
import { CustomerListItem } from '@core/models/customer.model';

@Component({
	selector: 'app-select-customer',
	templateUrl: './select-customer.component.html',
	styleUrls: ['./select-customer.component.scss'],
})
export class SelectCustomerComponent implements OnInit {
	@Input() loading = false;
	@Output() customerSelected = new EventEmitter<number>();

	customerList$: Observable<CustomerListItem[]>;
	customersForm = new UntypedFormGroup({
		customer: new UntypedFormControl(1, [Validators.required]),
	});

	constructor(private apiService: ApiService) {}

	ngOnInit(): void {
		this.customerList$ = this.apiService.getCustomerList();
	}

	onSubmit() {
		this.customerSelected.emit(this.customersForm.value.customer);
	}
}
